import React from 'react';
import { IconCheckmark } from '@zillow/constellation';
import * as S from './styles';

const ChecklistItem = (props = {}) => (
  <S.ChecklistItem>
    <S.Icon>
      <IconCheckmark fontColor="blue400" size="xs" />
    </S.Icon>
    <S.Label>{props.children}</S.Label>
  </S.ChecklistItem>
);

export default ChecklistItem;
